const MAX_WALLETS = 5;

function storageKey(userId) {
  return `saved_payout_wallets_${userId}`;
}

export function loadSavedWallets(userId) {
  if (!userId || typeof window === "undefined") return [];
  try {
    const raw = localStorage.getItem(storageKey(userId));
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveWallet(userId, wallet) {
  if (!userId) return [];
  const list = loadSavedWallets(userId);
  const next = [
    wallet,
    ...list.filter(
      (w) =>
        !(w.bank_id === wallet.bank_id && w.account_number === wallet.account_number)
    ),
  ].slice(0, MAX_WALLETS);
  localStorage.setItem(storageKey(userId), JSON.stringify(next));
  return next;
}

export function deleteWallet(userId, walletId) {
  if (!userId) return [];
  const next = loadSavedWallets(userId).filter((w) => w.id !== walletId);
  localStorage.setItem(storageKey(userId), JSON.stringify(next));
  return next;
}

export function maskAccount(value) {
  const text = String(value || "").trim();
  if (text.length <= 4) return text;
  return `•••• ${text.slice(-4)}`;
}
